<template>
  <ConfigLayout current="customer/option">
    <ConfigPage title="顧客情報項目の並べ替え" showBack @back="goBack">
      <template #header>
        <Button @click="goBack">キャンセル</Button>
        <Button class="is-lead" @click="onSave" :disabled="!changed">保存</Button>
      </template>
      <p>
        顧客情報に20件まで項目を追加することができます。<br />
        項目名に対する入力枠の形式を選んでください。顧客情報登録時に選択した入力フォームが表示されます。<br />
        ※追加した顧客情報項目は同じ企業にひもづく台帳で共通の設定となり、編集、削除を行うと、同じ企業にひもづく台帳すべてに反映されますのでご注意ください。
      </p>
      <DraggableTable
        class="option-list"
        v-model="optionOrders"
        :columns="[
          { key: 'label', name: '項目名' },
          { key: 'inputType', name: '形式', format: inputType => ({ 1: '入力式', 5: '選択式' }[inputType]) },
        ]"
        :minItemHeight="56"
        nodata="該当する顧客情報項目はありません"
        :loading="busy"
      >
      </DraggableTable>
    </ConfigPage>
  </ConfigLayout>
</template>

<script>
import { mapState } from 'vuex'
import { isEqual } from 'lodash'
import ConfigLayout from '@/components/templates/ConfigLayout'
import ConfigPage from '@/components/templates/ConfigPage'
import Button from '@/components/atoms/Button'
import DraggableTable from '@/components/molecules/DraggableTable'

export default {
  name: 'Options',
  components: {
    ConfigLayout,
    ConfigPage,
    Button,
    DraggableTable,
  },
  data() {
    return {
      optionItemIds: null,
    }
  },
  computed: {
    ...mapState({
      options: state => state.customers.options,
      busy: state => state.customers.options.busy,
    }),
    optionOrders: {
      get() {
        return (this.optionItemIds || this.options.allIds).map(id => this.options.byId[id])
      },
      set(options) {
        this.optionItemIds = options.map(option => option.id)
      },
    },
    changed() {
      return !!this.optionItemIds && !isEqual(this.optionItemIds, this.options.allIds)
    },
  },
  watch: {
    changed() {
      this.$store.commit('app/editing', this.changed)
    },
  },
  mounted() {
    this.$store.dispatch('customers/options/get')
  },
  methods: {
    async onSave() {
      if (await this.$store.dispatch('customers/options/saveOrder', this.optionItemIds)) {
        this.goBack()
      }
    },
    goBack() {
      this.$store.commit('app/editing', false)
      window.history.length > 1 ? this.$router.back() : this.$router.push({ name: 'option' })
    },
  },
}
</script>

<style lang="postcss" scoped>
.option-list {
  >>> .inputType {
    justify-content: center;
    min-width: 93px;
    width: 93px;
  }
}
</style>
